<div class="row row--info">
  <div class="col-sm-12 quote-topbar">
    <div class="quote-topbar__left">
      <button
        pButton
        [text]="true"
        size="small"
        (click)="close()"
        data-cy="back-to-list"
      >
        <i class="pi pi-angle-left"></i> Back
      </button>

      <app-quote-variant-select
        [quote]="quote"
        (quoteChange)="onQuoteVariantChange($event)"
      >
      </app-quote-variant-select>
    </div>
  </div>
</div>

@if (quote) {
  <div class="quote-dialog card-box card-box-dark">
    <div class="row">
      <div class="col-sm-10"></div>
      <div class="col-sm-2">
        @if (quote.status === quoteStatus.accepted && deepLink) {
          <a
            pButton
            severity="success"
            [fluid]="true"
            [href]="deepLink"
            target="_blank"
            data-cy="booking-add"
            class="m-b-20"
          >
            <i class="pi pi-plus"></i> Create booking
          </a>
        }
      </div>
    </div>

    @if (quote.getClientEmailDetails()) {
      <div class="row email-preview-row">
        <div class="col-12">
          <app-quote-email-preview
            [details]="quote.getClientEmailDetails()"
            [quoteId]="quote.getId()"
            [canDelete]="canDeleteAttachments()"
          ></app-quote-email-preview>
        </div>
      </div>
    }
    <p-panel #header class="header clear-p-panel">
      @if (isQuoteFormBlocked() || isOnlineQuoteHeaderBlocked()) {
        <div class="p-blockui ui-widget-overlay"></div>
      }

      <div class="quote-header__title-row">
        <div class="quote-header__identity">
          <h4 class="page-title">Quote</h4>
          <div class="quote-header__number">
            <span class="quote-header__number-label">Number:</span>
            <span class="quote-header__number-value" data-cy="quote-number">
              #{{ quote?.getDisplayId() }}
            </span>
          </div>
        </div>

        <div class="quote-header__meta">
          @if (quote.getSender() && quote.getStatus() !== quoteStatus.draft) {
            <span class="quote-header__meta-line sender">
              Sent by: {{ quote.getSender()?.getUsername() }}
            </span>
          }
          @if (loading) {
            <span class="quote-header__meta-line"> Saving Quote... </span>
          }
          @if (!loading && quote.getUpdatedAt() !== null) {
            <span class="quote-header__meta-line update-status">
              Saved: <strong>{{ quote.getUpdatedAt() | timeAgo }}</strong> by
              <strong>{{ quote.updatedBySenderCreatorName }}</strong>
            </span>
          }
          <div class="filter-field quote-header__internal-id">
            <span class="filter-field__label">Internal ID:</span>
            <input
              pInputText
              type="text"
              (change)="updateQuote({ ref: $event.target.value })"
              [value]="quote.getRef()"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="quote-header__row">
        <div class="filter-field quote-header__field--client">
          <span class="filter-field__label required">Account:</span>
          <app-client-select
            data-cy="quote-client-name"
            [disabled]="isNegotiatedQuote() || isQuoteSourceOnline()"
            [required]="true"
            [user]="user"
            [clients]="$safeNavigationMigration(quote?.getClients())"
            (clientSelected)="updateQuote({ clients: $event })"
          >
          </app-client-select>
        </div>

        <div class="filter-field quote-header__field--validity">
          <span class="filter-field__label">Quote validity:</span>
          <div class="validity-range__wrapper">
            <div class="validity-range__picker" id="e-quote-validity">
              <app-date-picker
                [selectedRange]="selectedRange"
                inputClass="p-inputtext"
                [showIcon]="true"
                [showTime]="isPtlQuote()"
                [showButtonBar]="!isPtlQuote()"
                [disabled]="!isFirstTabActive()"
                (rangeChange)="selectDate($event)"
              >
              </app-date-picker>
              @if (!hasValidDate()) {
                <i
                  class="pi pi-exclamation-triangle"
                  pTooltip="Date range might not be valid."
                  tooltipPosition="right"
                >
                </i>
              }
              @if (getQuoteValidityWarning()) {
                <i
                  class="pi pi-exclamation-triangle"
                  [pTooltip]="getQuoteValidityWarning()"
                  tooltipPosition="right"
                  data-cy="quote-validity-range-warning"
                >
                </i>
              }
            </div>
          </div>
        </div>

        @if (isLtlQuote()) {
          <div class="filter-field quote-header__field--date">
            <span class="filter-field__label">Pickup Date:</span>
            <p-datepicker
              dateFormat="dd.mm.y"
              firstDayOfWeek="1"
              [disabled]="!isFirstTabActive()"
              [ngModel]="getIntendedPickupDate()"
              (ngModelChange)="onIntendedPickupDateChange($event)"
              [showIcon]="true"
              [minDate]="today"
            >
              <ng-template #date let-date>
                <span [class.line-through]="date < today">{{ date.day }}</span>
              </ng-template>
            </p-datepicker>
          </div>
        }

        @if (isPtlQuote()) {
          <div class="filter-field quote-header__field--date-range">
            <span class="filter-field__label filter-field__label--toggle">
              <p-checkbox
                [binary]="true"
                [disabled]="!isFirstTabActive()"
                [ngModel]="isPtlPickupEnabled()"
                (ngModelChange)="onPtlPickupEnabledChange($event)"
                data-cy="quote-pickup-range-toggle"
              >
              </p-checkbox>
              Pickup:
            </span>
            <div class="validity-range__wrapper">
              <div class="validity-range__picker">
                <app-date-picker
                  [selectedRange]="getPtlPickupRange()"
                  inputClass="p-inputtext"
                  [showIcon]="true"
                  [showButtonBar]="false"
                  [showTime]="true"
                  [disabled]="!isPtlPickupEnabled() || !isFirstTabActive()"
                  (rangeChange)="onPtlPickupRangeChange($event)"
                >
                </app-date-picker>
                @if (getPtlPickupWarning()) {
                  <i
                    class="pi pi-exclamation-triangle"
                    [pTooltip]="getPtlPickupWarning()"
                    tooltipPosition="right"
                    data-cy="quote-pickup-range-warning"
                  >
                  </i>
                }
              </div>
            </div>
          </div>
          <div class="filter-field quote-header__field--date-range">
            <span class="filter-field__label filter-field__label--toggle">
              <p-checkbox
                [binary]="true"
                [disabled]="!isFirstTabActive()"
                [ngModel]="isPtlDeliveryEnabled()"
                (ngModelChange)="onPtlDeliveryEnabledChange($event)"
                data-cy="quote-delivery-range-toggle"
              >
              </p-checkbox>
              Delivery:
            </span>
            <div class="validity-range__wrapper">
              <div class="validity-range__picker">
                <app-date-picker
                  [selectedRange]="getPtlDeliveryRange()"
                  inputClass="p-inputtext"
                  [showIcon]="true"
                  [showButtonBar]="false"
                  [showTime]="true"
                  [disabled]="!isPtlDeliveryEnabled() || !isFirstTabActive()"
                  (rangeChange)="onPtlDeliveryRangeChange($event)"
                >
                </app-date-picker>
                @if (getPtlDeliveryWarning()) {
                  <i
                    class="pi pi-exclamation-triangle"
                    [pTooltip]="getPtlDeliveryWarning()"
                    tooltipPosition="right"
                    data-cy="quote-delivery-range-warning"
                  >
                  </i>
                }
              </div>
            </div>
          </div>
        }

        <div
          class="quote-header__options quote-header__options--classification"
        >
          <div
            class="filter-field"
            [class.blockui-exempt]="isQuoteTypeExemptFromBlock()"
          >
            <span class="filter-field__label">Quote type:</span>
            <p-select
              [disabled]="
                (!isFirstTabActive() || isNegotiatedQuote()) && !isEmailQuote()
              "
              [(ngModel)]="selectedQuoteType"
              [options]="quoteTypeList"
              (onChange)="onQuoteTypeChange()"
              class="green-dropdown"
              data-cy="quote-type-dropdown"
              appendTo="body"
            >
            </p-select>
          </div>

          @if (areIncoTermsVisible()) {
            <div class="filter-field">
              <span class="filter-field__label">Incoterms:</span>
              <p-select
                [disabled]="!isFirstTabActive()"
                [options]="incotermsList"
                [(ngModel)]="selectedIncotermType"
                placeholder="Please select"
                (onChange)="selectIncoterm($event.value)"
                class="green-dropdown"
                data-cy="quote-incoterms-dropdown"
                appendTo="body"
              >
              </p-select>
            </div>
          }

          @if (isQuoteDirectionVisible()) {
            <div class="filter-field">
              <span class="filter-field__label">Direction:</span>
              <p-selectbutton
                [disabled]="!isFirstTabActive()"
                [(ngModel)]="selectedDirection"
                [options]="directionList"
                (onChange)="updateQuote({ direction: selectedDirection })"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="false"
                size="small"
                data-cy="quote-direction-dropdown"
              >
              </p-selectbutton>
            </div>
          }
        </div>

        <div class="quote-header__options quote-header__options--cargo">
          @if (isAirTariffQuote()) {
            <div class="filter-field">
              <app-air-weight-bracket-select
                label="Weight Brackets:"
                data-cy="quote-weight-bracket-dropdown"
                [disabled]="!isFirstTabActive()"
                [selectedWeightBrackets]="quote.getWeightBrackets()"
                (selectionChange)="selectWeightBrackets($event)"
              >
              </app-air-weight-bracket-select>
            </div>
          }

          @if (
            (isFclQuoteOrFclTariff() || isMultiQuote()) && !isBrokerageQuote()
          ) {
            <div class="filter-field">
              <app-container-select
                label="Equipment:"
                data-cy="quote-equipment-dropdown"
                [disabled]="!isFirstTabActive()"
                [required]="isEquipmentRequired()"
                [selectedContainers]="quote.getEquipment()"
                (selectionChange)="selectEquipment($event)"
              >
              </app-container-select>
            </div>
          }

          @if (isAirQuote()) {
            <div class="filter-field">
              <span class="filter-field__label">Service Code:</span>
              <app-service-code-select
                data-cy="quote-service-code-dropdown"
                [disabled]="!isFirstTabActive()"
                [selectedServiceCodes]="quote.getServiceCodes()"
                (selectionChange)="selectServiceCodes($event)"
              >
              </app-service-code-select>
            </div>
          }
        </div>

        @if (isBaseLclQuote()) {
          <div class="quote-header__shipment">
            <div class="quote-header__options quote-header__options--measures">
              <div
                class="filter-field quote-header__field--number-wide"
                [pTooltip]="measuresLockedTooltip"
                [tooltipDisabled]="!areMeasuresLockedByPackages()"
                tooltipPosition="top"
              >
                <span
                  class="filter-field__label"
                  [class.required]="isWeightRequired()"
                  >Weight (kg):</span
                >
                <input
                  pInputText
                  type="text"
                  [required]="isWeightRequired()"
                  pattern="(?=.*[1-9])([0-9]*[.,])?[0-9]+"
                  (change)="onWeightChange($event)"
                  [ngModel]="getLclAndAirWeight()"
                  class="form-control"
                  [disabled]="
                    !isFirstTabActive() || areMeasuresLockedByPackages()
                  "
                  data-cy="quote-weight"
                />
              </div>
              <div
                class="filter-field quote-header__field--number"
                [pTooltip]="measuresLockedTooltip"
                [tooltipDisabled]="!areMeasuresLockedByPackages()"
                tooltipPosition="top"
              >
                <span
                  class="filter-field__label"
                  [class.required]="isMeasurementRequired()"
                  >CBM:</span
                >
                <input
                  pInputText
                  type="text"
                  [required]="isMeasurementRequired()"
                  [pattern]="getMeasurementPattern()"
                  (change)="onMeasurementChange($event)"
                  [ngModel]="getLclAndAirMeasurement()"
                  class="form-control"
                  [disabled]="
                    !isFirstTabActive() || areMeasuresLockedByPackages()
                  "
                  data-cy="quote-measurement"
                />
              </div>

              @if (isAirQuote()) {
                <div class="filter-field quote-header__field--number">
                  <span class="filter-field__label">Density (kg):</span>
                  <input
                    pInputText
                    type="text"
                    [value]="quote.getDensity()"
                    disabled="disabled"
                    class="form-control"
                  />
                </div>
              }

              <div
                class="filter-field quote-header__field--number"
                [pTooltip]="measuresLockedTooltip"
                [tooltipDisabled]="!areMeasuresLockedByPackages()"
                tooltipPosition="top"
              >
                <span
                  class="filter-field__label"
                  [class.required]="isLdmRequired()"
                  >LDM:</span
                >
                <input
                  pInputText
                  type="text"
                  [required]="isLdmRequired()"
                  pattern="(?=.*[1-9])([0-9]*[.,])?[0-9]+"
                  (change)="onLdmChange($event)"
                  [ngModel]="getLdm()"
                  class="form-control"
                  [disabled]="
                    !isFirstTabActive() || areMeasuresLockedByPackages()
                  "
                  data-cy="quote-ldm"
                />
              </div>
              <div
                class="filter-field quote-header__field--number"
                [pTooltip]="measuresLockedTooltip"
                [tooltipDisabled]="!areMeasuresLockedByPackages()"
                tooltipPosition="top"
              >
                <span
                  class="filter-field__label"
                  [class.required]="isPiecesRequired()"
                  >PCS:</span
                >
                <input
                  pInputText
                  type="number"
                  [required]="isPiecesRequired()"
                  [min]="getPiecesMin()"
                  step="1"
                  (change)="onPiecesChange($event)"
                  [ngModel]="getLclAndAirPieces()"
                  class="form-control"
                  [disabled]="
                    !isFirstTabActive() || areMeasuresLockedByPackages()
                  "
                  data-cy="quote-pieces"
                />
              </div>
              <app-quote-package
                [quote]="quote"
                [disabled]="
                  areQuoteChipsBlocked() || isOnlineQuoteHeaderBlocked()
                "
                [showLdm]="true"
                [showPallets]="true"
                [showCentimeters]="true"
                (apply)="updateQuote($event)"
                (refreshQuote)="onQuoteAi($event)"
              >
              </app-quote-package>
            </div>
            @if (hasPackages()) {
              <div
                class="quote-header__package-summary"
                data-cy="quote-package-summary"
              >
                <span class="quote-header__package-summary-item">
                  <i class="pi pi-box" aria-hidden="true"></i>
                  {{ getPackageTypesLabel() }}
                </span>
                @if (getPalletCount() > 0) {
                  <span class="quote-header__package-summary-item">
                    <i class="pi pi-bars" aria-hidden="true"></i>
                    {{ getPalletsLabel() }}
                  </span>
                }
                <span class="quote-header__package-summary-item">
                  <i class="pi pi-th-large" aria-hidden="true"></i>
                  {{ getStackabilityLabel() }}
                </span>
              </div>
            }
          </div>
        }

        <div class="quote-header__toggles">
          @if ((isFclQuote() || isBaseLclQuote()) && !isMultiQuote()) {
            <app-quote-ai
              class="transparent"
              [quote]="quote"
              [disabled]="areQuoteChipsBlocked()"
              (refreshQuote)="onQuoteAi($event)"
            ></app-quote-ai>
          }
          @if (areLocationChipsVisible()) {
            <app-quote-insurance
              variant="header"
              [quote]="quote"
              [user]="user"
              [disabled]="
                areQuoteChipsBlocked() || isOnlineQuoteHeaderBlocked()
              "
              (apply)="updateQuote($event)"
            >
            </app-quote-insurance>
          }
        </div>
      </div>
    </p-panel>
    <p-panel #chipsPanel class="clear-p-panel chips-row">
      @if (areLocationChipsVisible()) {
        <div class="row">
          @if (areQuoteChipsBlocked() || isQuoteSourceOnline()) {
            <div class="p-blockui ui-widget-overlay"></div>
          }
          <div class="col-12 col-md-6 chips-col">
            @if (
              !isLtlQuote() && !isMultiQuote() && !isFtlQuote() && !isPtlQuote()
            ) {
              <app-quote-chips
                #OriginLocationChips
                data-cy="origin-locations"
                [type]="chip.origin"
                [quote]="quote"
                [hasLocation]="quote.getHasOrigin()"
                [locations]="getChipLocationInput(chip.origin)"
                [locationKindFilter]="locationKindFilter"
                [locationKindFilterOptions]="locationKindFilterOptions"
                (locationChange)="onLocationChange($event)"
                (hasLocationChange)="
                  updateQuote({ hasOrigin: $event });
                  quote.setHasOrigin($event);
                  showFirstTab()
                "
                (locationKindFilterChange)="
                  onChipsLocationKindFilterChange($event)
                "
              ></app-quote-chips>
            }
            @if (isLtlQuote() || isFtlQuote() || isPtlQuote()) {
              <app-quote-chips-single
                [type]="chip.origin"
                [quote]="quote"
                [locations]="getChipLocationInput(chip.origin)"
                [locationKindFilter]="locationKindFilter"
                [locationKindFilterOptions]="locationKindFilterOptions"
                (locationChange)="onLocationChange($event)"
                (locationKindFilterChange)="
                  onChipsLocationKindFilterChange($event)
                "
              ></app-quote-chips-single>
            }
            @if (isMultiQuote()) {
              <app-quote-chips-group
                [type]="chip.origin"
                [quote]="quote"
                [locations]="getChipLocationInput(chip.origin)"
                (locationChange)="onLocationChange($event)"
              ></app-quote-chips-group>
            }
            <i class="pi right-arrow pi-angle-right"></i>
          </div>
          <div class="col-12 col-md-6 chips-col">
            @if (
              !isLtlQuote() && !isMultiQuote() && !isFtlQuote() && !isPtlQuote()
            ) {
              <app-quote-chips
                #DestinationLocationChips
                data-cy="destination-locations"
                [type]="chip.destination"
                [quote]="quote"
                [hasLocation]="quote.getHasDestination()"
                [locations]="getChipLocationInput(chip.destination)"
                [locationKindFilter]="locationKindFilter"
                [locationKindFilterOptions]="locationKindFilterOptions"
                (locationChange)="onLocationChange($event)"
                (hasLocationChange)="
                  updateQuote({ hasDestination: $event });
                  quote.setHasDestination($event);
                  showFirstTab()
                "
                (locationKindFilterChange)="
                  onChipsLocationKindFilterChange($event)
                "
              ></app-quote-chips>
            }
            @if (isLtlQuote() || isFtlQuote() || isPtlQuote()) {
              <app-quote-chips-single
                [type]="chip.destination"
                [quote]="quote"
                [locations]="getChipLocationInput(chip.destination)"
                [locationKindFilter]="locationKindFilter"
                [locationKindFilterOptions]="locationKindFilterOptions"
                (locationChange)="onLocationChange($event)"
                (locationKindFilterChange)="
                  onChipsLocationKindFilterChange($event)
                "
              ></app-quote-chips-single>
            }
            @if (isMultiQuote()) {
              <app-quote-chips-group
                [type]="chip.destination"
                [quote]="quote"
                [locations]="getChipLocationInput(chip.destination)"
                (locationChange)="onLocationChange($event)"
              ></app-quote-chips-group>
            }
          </div>
        </div>
      }
    </p-panel>
    @if (quote.isValid() && hasResolvedLocations()) {
      <div class="row">
        <div class="col-md-12">
          <p-tabs [value]="activeTab" (valueChange)="selectTab($event)">
            <p-tablist>
              @if (quote.getQuoteType() === quoteType.manual) {
                <p-tab [value]="tabs.quote">Quote</p-tab>
              }
              @if (quote.getQuoteType() === quoteType.fclTariff) {
                <p-tab [value]="tabs.contracts">{{ tabs.contracts }}</p-tab>
              }
              @if (isFreightTabVisible()) {
                <p-tab [value]="tabs.freight">{{ tabs.freight }}</p-tab>
              }
              @if (
                quote.getQuoteType() === quoteType.fcl ||
                quote.getQuoteType() === quoteType.brokerage ||
                quote.getQuoteType() === quoteType.lcl ||
                quote.getQuoteType() === quoteType.air ||
                quote.getQuoteType() === quoteType.airtariff ||
                quote.getQuoteType() === quoteType.multi
              ) {
                <p-tab
                  [value]="tabs.charges"
                  data-cy="quote-tab-charges"
                  [disabled]="activeTab === tabs.charges && !isSendPossible()"
                  >{{ tabs.charges }}</p-tab
                >
              }
              @if (quote.getQuoteType() !== quoteType.email) {
                <p-tab
                  [value]="tabs.layout"
                  data-cy="quote-tab-layout"
                  [disabled]="activeTab === tabs.layout && !isSendPossible()"
                  >{{ tabs.layout }}</p-tab
                >
              }
              <p-tab
                [value]="tabs.email"
                data-cy="quote-tab-email"
                [disabled]="activeTab === tabs.email && !isSendPossible()"
                >{{ tabs.email }}</p-tab
              >
            </p-tablist>
            @if (quote.status === quoteStatus.pending) {
              <app-spinner
                [size]="80"
                class="quote-pending-spinner"
              ></app-spinner>
            }
            <p-tabpanels>
              <p-panel #content class="clear-p-panel">
                @if (isQuoteFormBlocked()) {
                  <div class="p-blockui ui-widget-overlay"></div>
                }
                <div class="col-xs-12">
                  @if (activeTab === tabs.quote) {
                    <div class="tab">
                      <div class="row">
                        <div class="col-md-12">
                          <app-quote-manual-editor
                            #ManualEditor
                            [quote]="quote"
                            (valueChanged)="updateQuote($event)"
                          >
                          </app-quote-manual-editor>
                        </div>
                      </div>
                    </div>
                  }
                  @if (activeTab === tabs.contracts) {
                    <div class="tab">
                      <app-quote-contract-list
                        #TariffContractList
                        [quote]="quote"
                        (contractSelect)="updateQuote($event)"
                        (tierSelect)="updateQuote($event)"
                      ></app-quote-contract-list>
                    </div>
                  }
                  @if (activeTab === tabs.freight) {
                    <div class="tab">
                      <div class="row">
                        @if (isMultiQuote()) {
                          <div class="col-md-12">
                            @for (childQuote of childQuotes; track childQuote) {
                              <app-quote-freight-rate
                                [batchActionsAvailable]="false"
                                [agentRequestsVisible]="false"
                                [quote]="childQuote"
                                [quoteLoading]="loading"
                                [equipment]="getFclEquipment()"
                                [locationKindFilter]="locationKindFilter"
                                [locationKindFilterOptions]="
                                  locationKindFilterOptions
                                "
                                (routeDetect)="onRouteDetect($event)"
                              ></app-quote-freight-rate>
                            }
                          </div>
                        } @else {
                          <div class="col-md-12">
                            <app-quote-freight-rate
                              [quote]="quote"
                              [quoteLoading]="loading"
                              [equipment]="getFclEquipment()"
                              [locationKindFilter]="locationKindFilter"
                              [locationKindFilterOptions]="
                                locationKindFilterOptions
                              "
                              (routeDetect)="onRouteDetect($event)"
                            ></app-quote-freight-rate>
                          </div>
                        }
                      </div>
                      @if (isLtlQuote() || isFtlQuote() || isPtlQuote()) {
                        <div>
                          <app-quote-ltl-surcharge
                            #SurchargeTypeMultiselect
                            [quote]="quote"
                            [rates]="selectedRates"
                            (selectionChangeStart)="
                              onQuoteSurchargeSelectionStart()
                            "
                            (selectionChange)="
                              onQuoteSurchargeSelectionChange()
                            "
                          >
                          </app-quote-ltl-surcharge>
                        </div>
                      }
                    </div>
                  }
                  @if (activeTab === tabs.charges) {
                    <div class="tab">
                      @if (isMultiQuote()) {
                        <div class="col-md-12">
                          @for (childQuote of childQuotes; track childQuote) {
                            <div>
                              @if (haveRoute[childQuote.getId()]) {
                                <app-quote-surcharge
                                  [quote]="childQuote"
                                  [canChangeLabel]="false"
                                  [agentRequestsVisible]="false"
                                  (localCostLabelsChange)="
                                    updateQuote({ localCostLabels: $event })
                                  "
                                >
                                </app-quote-surcharge>
                              }
                            </div>
                          }
                        </div>
                      } @else {
                        <app-quote-surcharge
                          [quote]="quote"
                          [rates]="selectedRates"
                          (localCostLabelsChange)="
                            updateQuote({ localCostLabels: $event })
                          "
                        >
                        </app-quote-surcharge>
                      }
                    </div>
                  }
                  @if (activeTab === tabs.layout) {
                    <div class="tab">
                      <div class="row">
                        <div class="col-md-4">
                          <app-quote-options
                            [quote]="quote"
                            [showCurrencyOptions]="
                              getCurrencyOptionsVisibility()
                            "
                            [routeCount]="routeCount"
                            [termsEditorEnabled]="
                              this.QuoteTerms()
                                ? this.QuoteTerms().editorEnabled
                                : false
                            "
                            [user]="user"
                            [insuranceDisabled]="
                              isQuoteFormBlocked() ||
                              isOnlineQuoteHeaderBlocked()
                            "
                            (quoteChange)="updateQuote($event)"
                            (termsChange)="
                              this.QuoteTerms().toggleEditor($event)
                            "
                            (locationSelect)="updateQuote($event)"
                            (insuranceApply)="updateQuote($event)"
                          ></app-quote-options>
                          <app-quote-terms
                            #QuoteTerms
                            [quote]="quote"
                            (termsChange)="termsSubject.next($event)"
                          >
                          </app-quote-terms>
                        </div>
                        <div class="col-md-8">
                          @if (isQuotePreviewVisible()) {
                            <app-quote-preview
                              [quoteLoading]="loading"
                              #Preview
                              [quote]="quote"
                            ></app-quote-preview>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (activeTab === tabs.email) {
                    <div class="tab">
                      <app-quote-mail-editor
                        #MailEditor
                        [quote]="quote"
                        (emailChange)="updateQuote($event)"
                        (validityChange)="setSendButtonVisibility($event)"
                      ></app-quote-mail-editor>
                    </div>
                  }
                  @if (isOfferCommentVisible()) {
                    <div id="offer-comment">
                      <label
                        class="field-toggle field-toggle--offer"
                        for="show-offer-comment"
                      >
                        <p-checkbox
                          [(ngModel)]="showOfferComment"
                          (onChange)="toggleOfferComment()"
                          binary="true"
                          inputId="show-offer-comment"
                        >
                        </p-checkbox>
                        <i
                          class="field-toggle__icon pi pi-comment"
                          aria-hidden="true"
                        ></i>
                        <span class="field-toggle__text"
                          >Add comment
                          <small>(visible on the offer)</small></span
                        >
                      </label>
                      @if (showOfferComment) {
                        <app-wysiwyg
                          class="comment-editor"
                          [value]="getComment()"
                          (valueChanged)="updateQuote({ comment: $event })"
                        >
                        </app-wysiwyg>
                      }
                    </div>
                  }
                  @if (isInternalCommentVisible()) {
                    <div id="internal-comment">
                      <label
                        class="field-toggle field-toggle--internal"
                        for="show-internal-notes"
                      >
                        <p-checkbox
                          [(ngModel)]="showInternalNotes"
                          (onChange)="toggleInternalNotes()"
                          binary="true"
                          inputId="show-internal-notes"
                        >
                        </p-checkbox>
                        <i
                          class="field-toggle__icon pi pi-clipboard"
                          aria-hidden="true"
                        ></i>
                        <span class="field-toggle__text"
                          >Add note <small>(internal use only)</small></span
                        >
                      </label>
                      @if (showInternalNotes) {
                        <textarea
                          pInputText
                          data-cy="quote-internal-comment"
                          [(ngModel)]="internalComment"
                          (keyup)="
                            this.internalCommentSubject.next(internalComment)
                          "
                          class="form-control"
                          [class.pop-out]="
                            quote.getStatus() !== quoteStatus.draft
                          "
                        >
                        </textarea>
                      }
                    </div>
                  }
                  @if (quote.reasonOfDecline) {
                    <div id="reason-of-decline" class="m-t-20">
                      Reason of decline:
                      {{ reasonOfDecline[quote.reasonOfDecline] }}
                    </div>
                  }
                </div>
              </p-panel>
            </p-tabpanels>
          </p-tabs>
        </div>
      </div>
    }
    <app-quote-form-actions
      [quote]="quote"
      [activeTab]="activeTab"
      [isMailFormValid]="isMailFormValid"
      [isNextTabPossible]="quote.isValid() && hasResolvedLocations()"
      (nextTab)="nextTab()"
      (quoteClosed)="close()"
      (quoteDeleted)="close()"
      (quoteSent)="checkQuotePotential()"
      (quoteReplicated)="onQuoteReplicated($event)"
      (quoteAccepted)="setQuote($event)"
      (quoteDeclined)="setQuote($event)"
    >
    </app-quote-form-actions>
    @if (potentialPopupVisible) {
      <app-client-potential-form
        [quote]="quote"
        (closeView)="goToQuoteList(); potentialPopupVisible = false"
      ></app-client-potential-form>
    }
  </div>
}
